import { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import apiClient from '../api/client';

// Bridge page for TikTok's OAuth redirect.
// TikTok bounces creators back to https://app.streamersconnected.com/oauth/tiktok/callback?code=...&state=...
// We forward those params to the backend (with the admin's bearer token),
// the backend exchanges the code for tokens + pulls profile/video data,
// then we redirect to the creator's profile.

const TikTokOAuthCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [status, setStatus] = useState('Connecting your TikTok account...');
  const [error, setError] = useState('');

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const tiktokError = searchParams.get('error');
    const errorDesc = searchParams.get('error_description');

    if (tiktokError) {
      setStatus('');
      setError(`TikTok rejected the request: ${tiktokError}${errorDesc ? ` — ${errorDesc}` : ''}`);
      return;
    }

    if (!code || !state) {
      setStatus('');
      setError('Missing code or state in callback URL.');
      return;
    }

    (async () => {
      try {
        const { data } = await apiClient.post('/tiktok/oauth/exchange', { code, state });
        setStatus(`Connected as @${data.profile?.username || 'TikTok user'}. Redirecting...`);
        setTimeout(() => {
          navigate(`/dashboard/creators/${data.creatorId}`);
        }, 1200);
      } catch (e) {
        setStatus('');
        setError(e.response?.data?.error || e.message || 'Failed to complete TikTok connection.');
      }
    })();
  }, [searchParams, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#0b0b1a',
      color: '#fff',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <div style={{
        background: 'rgba(255,255,255,0.06)',
        border: '1px solid rgba(255,255,255,0.12)',
        borderRadius: 12,
        padding: '32px 40px',
        maxWidth: 480,
        textAlign: 'center',
      }}>
        <h2 style={{ margin: '0 0 16px', fontSize: 22 }}>TikTok Connection</h2>
        {status && <p style={{ margin: 0, opacity: 0.85 }}>{status}</p>}
        {error && (
          <>
            <p style={{ margin: '0 0 16px', color: '#ff6b6b' }}>{error}</p>
            <button
              onClick={() => navigate('/dashboard')}
              style={{
                background: '#fe2388',
                color: '#fff',
                border: 'none',
                padding: '10px 20px',
                borderRadius: 6,
                cursor: 'pointer',
                fontSize: 14,
              }}
            >
              Back to dashboard
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default TikTokOAuthCallback;
